import React from "react";
import styles from "./css/subscription.module.css";

// Loading skeleton mirroring the Subscription page layout (plan card + addons
// + sticky payment sidebar). Swaps in for ResponseLoader during
// isLicenseLoading / pricing-catalog loading states.
function SubscriptionSkeleton() {
  return (
    <div className={styles.emPageWrapper}>
      <div className={styles.emPageHeader}>
        <h1 className={styles.emPageTitle}>Subscriptions</h1>
        <div className={`shimmer ${styles.skeletonPill}`} />
      </div>

      <div className={styles.emParent}>
        <div className={styles.emLeftCol}>
          <div className={styles.emPlanCard}>
            <div className={styles.emCardHeader}>
              <div
                className={`shimmer ${styles.skeletonBlock}`}
                style={{ width: "220px", height: "24px" }}
              />
              <div
                className={`shimmer ${styles.skeletonBlock}`}
                style={{ width: "140px", height: "36px", borderRadius: "8px" }}
              />
            </div>

            {[1, 2, 3].map((row) => (
              <div className={styles.emRow} key={row}>
                <div
                  className={`shimmer ${styles.skeletonBlock}`}
                  style={{ width: "140px", height: "16px" }}
                />
                <div
                  className={`shimmer ${styles.skeletonBlock}`}
                  style={{ width: "160px", height: "38px", borderRadius: "8px" }}
                />
              </div>
            ))}
          </div>

          <div className={styles.emAddonsCard}>
            <div
              className={`shimmer ${styles.skeletonBlock}`}
              style={{ width: "100px", height: "18px", marginBottom: "16px" }}
            />
            {[1, 2].map((row) => (
              <div className={styles.addonItem} key={row}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "12px",
                    padding: "16px 0",
                  }}
                >
                  <div
                    className={`shimmer ${styles.skeletonBlock}`}
                    style={{ width: "18px", height: "18px", flexShrink: 0 }}
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      className={`shimmer ${styles.skeletonRow} ${styles.skeletonRowShort}`}
                    />
                    <div
                      className={`shimmer ${styles.skeletonRow} ${styles.skeletonRowMedium}`}
                      style={{ marginBottom: 0 }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.emPaymentCard}>
          <div className={styles.emCardHeader}>
            <div
              className={`shimmer ${styles.skeletonBlock}`}
              style={{ width: "150px", height: "22px" }}
            />
            <div
              className={`shimmer ${styles.skeletonPill}`}
              style={{ width: "70px", height: "24px" }}
            />
          </div>

          {[1, 2, 3, 4].map((row) => (
            <div className={styles.emPlanRow} key={row}>
              <div style={{ flex: 1 }}>
                <div
                  className={`shimmer ${styles.skeletonRow} ${styles.skeletonRowMedium}`}
                />
                <div
                  className={`shimmer ${styles.skeletonRow} ${styles.skeletonRowShort}`}
                  style={{ marginBottom: 0, height: "12px" }}
                />
              </div>
              <div
                className={`shimmer ${styles.skeletonBlock}`}
                style={{ width: "70px", height: "16px" }}
              />
            </div>
          ))}

          <div className={styles.emTotalRow}>
            <div
              className={`shimmer ${styles.skeletonBlock}`}
              style={{ width: "100px", height: "18px" }}
            />
            <div
              className={`shimmer ${styles.skeletonBlock}`}
              style={{ width: "90px", height: "22px" }}
            />
          </div>

          <div
            className={`shimmer ${styles.skeletonBlock}`}
            style={{ width: "100%", height: "48px", marginTop: "16px" }}
          />
        </div>
      </div>
    </div>
  );
}

export default SubscriptionSkeleton;